import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import apibridge from '../../apibridge';
import { AccountUserInfoTutorial, AccountUserInfoUserDetails } from '../../api/models';

export type UserType = {
	forceUpdate?: boolean;
	loggedIn?: boolean;
} & AccountUserInfoUserDetails;

const initialState: AccountUserInfoUserDetails = {
	id: '',
	firstName: '',
	lastName: '',
	email: '',
	activeProfileId: '',
	activeOrganisationId: '',
	profiles: [],
	permissions: [],
	loginStatus: undefined
};

export const UserSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		logOut: (state) => {
			apibridge.postLogout();
			state = Object.assign(state, {
				...initialState,
				forceUpdate: false,
				loggedIn: false
			});
		},
		update: (state, action: PayloadAction<UserType>) => {
			state = Object.assign(state, action.payload);
		},
		forceUpdate: (state) => {
			state = Object.assign(state, {
				forceUpdate: true
			});
		},
		setHelpDismissed: (state, action: PayloadAction<boolean>) => {
			state.helpDismissed = action.payload;
		},
		setUserOnboardingCompleted: (state, action: PayloadAction<boolean>) => {
			state.ftuxCompleted = action.payload;
		},
		dismissUserTutorial: (state, action: PayloadAction<string>) => {
			const tutorialType = action.payload;
			if (!state.tutorials) {
				state.tutorials = [];
			}
			const tutorial = state.tutorials.find((t) => t.type === tutorialType);
			if (tutorial) {
				tutorial.dismissed = true;
			} else {
				// If tutorial doesn't exist in state yet, add it
				state.tutorials.push({
					type: tutorialType as AccountUserInfoTutorial['type'],
					dismissed: true
				});
			}
		}
	}
});
